/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChefEntrepriseDisplayNameDto,
  ChefEntrepriseSelectorGridDtoPaginatedResults,
  ChefEntrepriseSelectorSearch,
  FilterCriteriaInfo,
  ReferentialItemDto,
} from '../models/index';
import {
    ChefEntrepriseDisplayNameDtoFromJSON,
    ChefEntrepriseDisplayNameDtoToJSON,
    ChefEntrepriseSelectorGridDtoPaginatedResultsFromJSON,
    ChefEntrepriseSelectorGridDtoPaginatedResultsToJSON,
    ChefEntrepriseSelectorSearchFromJSON,
    ChefEntrepriseSelectorSearchToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoToJSON,
} from '../models/index';

export interface ChefEntrepriseSelectorBaseSearchRequest {
    ChefEntrepriseSelectorSearch?: ChefEntrepriseSelectorSearch;
}

export interface ChefEntrepriseSelectorGetDisplayNamesRequest {
    idsiegeSocial?: number;
    request_body?: Array<number>;
}

export interface ChefEntrepriseSelectorGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface ChefEntrepriseSelectorGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class ChefEntrepriseSelectorApi extends runtime.BaseAPI {

    /**
     */
    async chefEntrepriseSelectorBaseSearchRaw(requestParameters: ChefEntrepriseSelectorBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChefEntrepriseSelectorGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ChefEntrepriseSelector/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChefEntrepriseSelectorSearchToJSON(requestParameters.ChefEntrepriseSelectorSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChefEntrepriseSelectorGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async chefEntrepriseSelectorBaseSearch(requestParameters: ChefEntrepriseSelectorBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChefEntrepriseSelectorGridDtoPaginatedResults> {
        const response = await this.chefEntrepriseSelectorBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chefEntrepriseSelectorGetDisplayNamesRaw(requestParameters: ChefEntrepriseSelectorGetDisplayNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChefEntrepriseDisplayNameDto>>> {
        const queryParameters: any = {};

        if (requestParameters.idsiegeSocial !== undefined) {
            queryParameters['idsiegeSocial'] = requestParameters.idsiegeSocial;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ChefEntrepriseSelector/GetDisplayNames`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.request_body,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChefEntrepriseDisplayNameDtoFromJSON));
    }

    /**
     */
    async chefEntrepriseSelectorGetDisplayNames(requestParameters: ChefEntrepriseSelectorGetDisplayNamesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChefEntrepriseDisplayNameDto>> {
        const response = await this.chefEntrepriseSelectorGetDisplayNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chefEntrepriseSelectorGetSearchCriteriasRaw(requestParameters: ChefEntrepriseSelectorGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ChefEntrepriseSelector/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async chefEntrepriseSelectorGetSearchCriterias(requestParameters: ChefEntrepriseSelectorGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.chefEntrepriseSelectorGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chefEntrepriseSelectorGetSelectItemsRaw(requestParameters: ChefEntrepriseSelectorGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferentialItemDto>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling chefEntrepriseSelectorGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/ChefEntrepriseSelector/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferentialItemDtoFromJSON));
    }

    /**
     */
    async chefEntrepriseSelectorGetSelectItems(requestParameters: ChefEntrepriseSelectorGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferentialItemDto>> {
        const response = await this.chefEntrepriseSelectorGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
